"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth0_react_1 = require("@auth0/auth0-react");
const theme_1 = require("../../theme");
const styled_components_1 = __importDefault(require("styled-components"));
const auth_1 = require("../../util/auth");
const routes_1 = require("../../util/routes");
const NavigationContext_1 = require("../../contexts/NavigationContext");
const UserNameCol = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  color: ${(p) => (p.$light ? "white" : "inherit")};
  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    align-items: center;
  }
  ${(p) => p.$hideOnBigScreen
    ? `
    @media (min-width: ${theme_1.breakpoints.tablet + 1}px) {
      display: none;
    }
    `
    : ""}
`;
const UserName = styled_components_1.default.div `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
  color: ${(p) => (p.$light ? "white" : theme_1.theme.colors.text)};
`;
const LogButton = styled_components_1.default.button `
  border: none;
  border-bottom: 1px solid
    ${(p) => (p.$light ? "white" : theme_1.theme.colors.bluelink)};
  ${theme_1.theme.fontSize(-1)};
  padding: 0;
  background-color: transparent;
  color: ${(p) => (p.$light ? "white" : theme_1.theme.colors.bluelink)};
  cursor: pointer;
`;
const Tools = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
`;
const UserSection = ({ light, hideOnBigScreen, }) => {
    const { loginWithRedirect, isAuthenticated, user, logout } = (0, auth0_react_1.useAuth0)();
    const { navigate } = (0, NavigationContext_1.useNavigation)();
    return ((0, jsx_runtime_1.jsxs)(UserNameCol, { "$light": light, "$hideOnBigScreen": hideOnBigScreen, children: [user && ((0, jsx_runtime_1.jsx)(UserName, { "$light": light, children: user.name ? user.name : user.email })), (0, jsx_runtime_1.jsxs)(Tools, { children: [isAuthenticated && (0, auth_1.isAdmin)(user) && ((0, jsx_runtime_1.jsx)(LogButton, { "$light": light, onClick: (e) => {
                            e.preventDefault();
                            navigate(`${routes_1.routeNames.admin}/${routes_1.routeNames.poolsAdmin}`);
                        }, children: "Admin" })), isAuthenticated ? ((0, jsx_runtime_1.jsx)(LogButton, { "$light": light, onClick: (e) => {
                            e.preventDefault();
                            logout({
                                logoutParams: { returnTo: window.location.origin },
                            });
                        }, children: "Log out" })) : ((0, jsx_runtime_1.jsx)(LogButton, { "$light": light, onClick: (e) => {
                            e.preventDefault();
                            loginWithRedirect();
                        }, children: "Log in" }))] })] }));
};
exports.UserSection = UserSection;
